import React from 'react';
import { NavLink } from 'react-router-dom';
import headerimage from '../../images/headerpic.jpg';

import './Navigation.css';

function Navigation() {
    const getLinkClass = ({ isActive }) => {
        return isActive ? "active" : "";
    };

    return (
        <div className="navbar">
            <h1>
                ACPT Construction (630)-771-1787
            </h1>
            <div className="headerimage">
                <img src={headerimage} alt="header roofing" />
            </div>
            <ul className="navlist">
                <li><NavLink to="/" className={getLinkClass} end>Home</NavLink></li>
                <li><NavLink to="/references" className={getLinkClass}>Completed Projects</NavLink></li>
                <li><NavLink to="/requestanestimate" className={getLinkClass}>Request an Estimate</NavLink></li>
                <li><NavLink to="/photogallery" className={getLinkClass}>Photo Gallery</NavLink></li>
                <li><NavLink to="/roofing" className={getLinkClass}>Roofing</NavLink></li>
                <li><NavLink to="/carpentry" className={getLinkClass}>Carpentry</NavLink></li>
                <li><NavLink to="/siding" className={getLinkClass}>Siding</NavLink></li>
            </ul>
        </div>
    );
}

export default Navigation;